import { Review } from "@app/types/review";
import reduce from "lodash/reduce";

export const totalPoint = (reviews: Review[] = []) => {
  if (!reviews.length) return 0;
  return reduce(reviews, (sum, item) => sum + item.point, 0) / reviews.length;
};
